import "ng-file-upload/dist/ng-file-upload";
import core from "@gtmhub/core/module";
import { FileService } from "./fileService";
import { GtmhubSrcDirective } from "./gh-src.directive";

const mod = angular.module("files", [core, "ngFileUpload"]);
mod.service("FileService", FileService);
mod.directive("ghSrc", GtmhubSrcDirective.factory());

export default mod.name;
